import { pk } from './config'
import NodeRSA from 'node-rsa'
import { JSEncrypt } from 'jsencrypt'
import moment from 'moment'

// await 错误处理方法
export async function awaitWrap (promise) {
  return await promise
    .then((data) => [null, data])
    .catch(err => [err, null])
}

export function limitStr (s, n) {
  if (s.length <= n) {
    return s
  }
  return `${s.slice(0, n)}...`
}

// 公钥加密
export function compress (v) {
  // const key = new NodeRSA(pk, undefined, { encryptionScheme: 'pkcs1' })
  // const str = key.encrypt(v, 'base64')
  try {
    const encryptTool = new JSEncrypt()
    encryptTool.setPublicKey(pk)
    const str = encryptTool.encrypt(v)
    if (typeof str === 'string') {
      return str
    }
  } catch (e) {
    console.error(e)
  }
  return ''
}

// 公钥解密
export function decompress (v) {
  try {
    if (typeof v === 'string' && v) {
      const key = new NodeRSA()
      key.importKey(pk)
      const str = key.decryptPublic(v, 'utf8')
      if (typeof str === 'string') {
        return str
      }
    }
  } catch (e) {
    console.error(e)
  }
  return v || ''
}

// 格式化案件件证件号
export function formatCaseDataLicenseAndMobile (d) {
  const keys = ['applicant_agents', 'applicants', 'respondents', 'respondents_agents']
  keys.forEach(key => {
    const arr = d[key]
    if (arr instanceof Array && arr.length > 0) {
      arr.forEach(li => {
        if (typeof li.license === 'string' && li.license.length > 0) {
          try {
            li.license = decompress(li.license)
          } catch (e) {
            console.error(e)
          }
        }
        if (typeof li.mobile === 'string' && li.mobile.length > 0) {
          try {
            li.mobile = decompress(li.mobile)
          } catch (e) {
            console.error(e)
          }
        }
      })
    }
  })
  return d
}

export function compressLicense (o) {
  if (o && typeof o.license === 'string' && o.license.length > 0) {
    o.license = compress(o.license)
  }
}

export function decompressLicense (o) {
  if (o && typeof o.license === 'string' && o.license.length > 0) {
    o.license = decompress(o.license)
  }
}

export function compressListLicense (l) {
  if (l instanceof Array && l.length > 0) {
    l.forEach(li => {
      compressLicense(li)
    })
  }
}

export function decomporessListLicense (l) {
  if (l instanceof Array && l.length > 0) {
    l.forEach(li => {
      decompressLicense(li)
    })
  }
}

// 格式化日期
export function formatDate (t, format = 'YYYY-MM-DD') {
  if (typeof t === 'number' && t > 0) {
    return moment(t * 1000).format(format)
  } else if (typeof t === 'string' && /^\d*$/.test(t)) {
    return moment(parseInt(t) * 1000).format(format)
  }
  return t
}
